import { IS_LOADING, SET_NOTE_COMMENTS } from "./siteMonitoringConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import moment from "moment";
import db from "../../db";
import { adaptCommentForDb, adaptCommentForMyOpen, adaptCommentForOpenERP } from "./siteMonitoringCast";
import { clone, guid } from "../../utils";

export function siteMonitoringsIsLoading(value) {
	return {
		type: IS_LOADING,
		info: "site_monitoring_comment",
		isLoading: value,
	};
}

export function setCommentsAction(comments) {
	return {
		type: SET_NOTE_COMMENTS,
		comments,
	};
}

export function clearComments() {
	return (dispatch) => {
		dispatch(setCommentsAction([]));
	}
}

function sortByDate(commentA, commentB) {
	if (moment(commentA.date).isBefore(moment(commentB.date))) return -1;

	if (moment(commentA.date).isAfter(moment(commentB.date))) return 1;

	return 0;
}

export function getComments(note) {
	return (dispatch) => {
		dispatch(siteMonitoringsIsLoading(true));
		db.SiteMonitoringComment.filter((comment) => {
			return comment.note_id === note.id;
		})
			.toArray()
			.then((comments) => {
				let transformedComments = [];
				comments.sort(sortByDate).forEach((c) =>
					transformedComments.push(adaptCommentForMyOpen(c))
				);

				dispatch(setCommentsAction(transformedComments));
				dispatch(siteMonitoringsIsLoading(false));
			})
			.catch((err) => {
				console.error("Erreur : noteActions - getComments", err);
				dispatch(
					throwErrorMessage({
						errorObject: err,
						title: "Erreur",
						message: "Erreur lors de la récupération des commentaires !",
					})
				);
				dispatch(siteMonitoringsIsLoading(false));
			});
	};
}

export function creatingComment(note, message, user) {
	return {
		body: message,
		note_id: note.id,
		date: moment(),
		create_uid: user,
	};
}

export function createComment(note, comment, user) {
	return (dispatch) => {
		const headers = new Headers({ "Content-Type": "application/json" });

		let commentForOpenErp = adaptCommentForOpenERP(comment);

		const body = {
			comment: commentForOpenErp,
			userId: user.id,
		};

		dispatch(siteMonitoringsIsLoading(true));

		fetchWithTimeout("/api/v1/siteMonitorings/comments/create", {
			method: "POST",
			headers: headers,
			body: JSON.stringify(body),
		})
			.then(function (response) {
				if (!response.ok) throw Error(response.statusText);

				return response;
			})
			.then((response) => response.json())
			.then((newCommentId) => {
				comment.id = newCommentId;

				db.SiteMonitoringComment.add(adaptCommentForDb(comment));
				dispatch(getComments(note));
				dispatch(siteMonitoringsIsLoading(false));
			})
			.catch((err) => {
				let message = "Une erreur s'est produite lors de la création du commentaire.";
				if (err.noNetworkError) {
					comment.id = guid();
					comment.guid = comment.id;
					db.SiteMonitoringComment.add(adaptCommentForDb(comment));
					dispatch(getComments(note));
					message += " Essayez de synchroniser la liste des chantiers afin d'être sûr que le commentaire soit envoyé";
				}

				console.error("Erreur : commentActions - createComment: " + err.message);
				dispatch(
					throwErrorMessage({
						title: "Erreur",
						message
					})
				);

				dispatch(siteMonitoringsIsLoading(false));
			});
	};
}

export function synchronizeComments(serverNote, user) {
	return (dispatch) => {
		db.SiteMonitoringComment.filter((comment) => {
			return comment.note_id === serverNote.id;
		})
			.toArray()
			.then((dbComments) => {
				let dbCommentsAlwaysInOpenErp = [];

				serverNote.message_ids.forEach((sc) => {
					let transformedServerComment = adaptCommentForMyOpen(sc);

					let dbComment = dbComments.find(
						(dbc) => dbc.id === sc.id
					);

					dbCommentsAlwaysInOpenErp = dispatch(
						synchronizeComment(dbComment, transformedServerComment, dbCommentsAlwaysInOpenErp, serverNote)
					);
				});

				dbComments.filter((dbc) => !dbCommentsAlwaysInOpenErp.includes(dbc)).forEach((dbc) => {
					if (dbc.mobile_id === dbc.id) {
						deleteComment(dbc);
						let clonedComment = clone(dbc);
						createComment(serverNote, clonedComment, user);
					}
				});

				dispatch(siteMonitoringsIsLoading(false));
			})
			.catch((err) => {
				console.error("Erreur : commentActions - synchronizeComments", err);
				dispatch(
					throwErrorMessage({
						errorObject: err,
						title: "Erreur",
						message: "Erreur lors de la synchronisation des commentaires !",
					})
				);
				dispatch(siteMonitoringsIsLoading(false));
			});
	};
}

export function deleteComment(comment) {
	db.SiteMonitoringComment.delete(comment.id);
}

export function synchronizeComment(
	dbComment,
	transformedServerComment,
	dbCommentsAlwaysInOpenErp,
	note
) {
	return () => {
		transformedServerComment.note_id = note.id;

		if (!dbComment) {
			db.SiteMonitoringComment.add(adaptCommentForDb(transformedServerComment));
		}
		else {
			dbCommentsAlwaysInOpenErp.push(dbComment);
			// db.SiteMonitoringComment.update(
			// 	transformedServerComment.id,
			// 	adaptCommentForDb(transformedServerComment)
			// );
		}

		return dbCommentsAlwaysInOpenErp;
	};
}
